<template>
  <div class="alert alert-secondary text-dark text-start">
    <ul>
      <li><b>Move camera</b>: 1 finger drag or Left Mouse Button</li>
      <li>
        <b>Pan</b>: 2-finger drag or Right Mouse Button or SHIFT+ Left Mouse
        Button
      </li>
      <li><b>Zoom on object</b>: Double-tap or Double-click on object</li>
      <li><b>Zoom out</b>: Double-tap or Double-click on background</li>
      <li>
        <b>Zoom</b>: Pinch in/out or Mousewheel or CTRL + Left Mouse Button
      </li>
      <li>
        Double-clicking the background will re-center the model and set the
        camera pivot point to the middle of its bounding box.
      </li>
      <li>
        Double-clicking anywhere on the model sets the camera pivot point to
        that spot.
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "CompletionAlert"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
